module.exports = __webpack_public_path__ + "static/fonts/DejaVuSans-Bold.21546d8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/DejaVu/DejaVuSans-Bold.ttf?v=1.1
// module id = 1634
// module chunks = 28